import React from 'react'
import classes from './CalculatorPreview.module.scss';
import renderHTML from 'react-render-html';
import { getFileName } from 'helpers/FileCaching';
import { Link  } from "react-router-dom";
import globalJSON from 'data/global.json';


const calculatorPreviewImages = require.context('../../../images/components/CalculatorPreview', true, /.*\.(gif|png|jpe?g|svg)$/i);

function CalculatorPreview({content, windowSize}){

    function onCalculatorClick(event){
        window.gtag('event', "Food calculator", {
            'event_category': globalJSON.tracking.ga_category,
            'event_label': "Food calculator promo "+ event.currentTarget.href,
            'value':10
        });
    }

	return (
        <div className={classes.CalculatorPreview}>
            <div className={`container-fluid`} style={{padding: 0}}>
                <div className={classes.CalculatorPreview__bgImage} style={{backgroundImage: `url(${getFileName(calculatorPreviewImages, content.bgImage[windowSize])})`}} title="Preview Calculator">
                    <div className={`row`}  style={{margin: 0}}>
                        <div  className={classes.CalculatorPreview__content}>
                            <p className={classes.CalculatorPreview__subtitle}>{renderHTML(content.subtitle)}</p>
                            <h3 className={classes.CalculatorPreview__title}>{renderHTML(content.title)}</h3>
                            <a onClick={onCalculatorClick} href={process.env.PUBLIC_URL+content.btn.url} rel="noopener noreferrer" target='_self' className={classes.CalculatorPreview__btn}>
                                <span>{content.btn.text}</span>
                            </a>
                            {/* <Link to={process.env.PUBLIC_URL+content.btn.url} className={classes.CalculatorPreview__btn}>
                          
                            </Link> */}
                        </div>   
                    </div>   
                </div>   
            </div>   
        </div>
        
	)
}

export default CalculatorPreview